<template>
    <v-card flat class="mt-3 pa-1" v-if="companies">
        <v-form ref="form">
                <v-layout row wrap>
                    <v-flex xs12 md6>
                        <v-text-field
                                class="pa-3"
                                v-model="serialNr"
                                label="Konteinera Nr"
                                color="deep-purple accent-3"
                                :rules="formRules"
                                required
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-autocomplete
                                clearable
                                class="pa-3"
                                v-model="company"
                                color="deep-purple accent-3"
                                item-text="name"
                                item-value="id"
                                :items="companies"
                                label="Īpašnieks"
                        ></v-autocomplete>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12 md6>
                        <v-text-field
                                class="pa-3"
                                v-model="volume"
                                label="Tilpums"
                                type="number"
                                color="deep-purple accent-3"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-text-field
                                class="pa-3"
                                color="deep-purple accent-3"
                                label="Ražošanas gads"
                                type="number"
                                v-model="year"
                        ></v-text-field>
                    </v-flex>
                </v-layout>

            <v-layout row wrap>
                <v-flex xs12 class="mb-3">
                    <div class="text-xs-center text-md-right">
                        <v-btn small flat @click="hideAddContainerModal" dark color="deep-orange lighten-1">
                            <v-icon dark left>block</v-icon>Atcelt</v-btn>
                        <v-btn small flat @click="submit" dark color="green accent-4">Pievienot
                            <v-icon dark right>check_circle</v-icon>
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</template>

<script>

    export default {
        name: "add-container-modal",
        props: ['companies'],
        data: () => ({
            serialNr: '',
            company: '',
            year: '',
            volume: '',
            formRules: [
                v => !!v || 'Šis lauks ir obligāts',
            ],
        }),
        methods: {
            hideAddContainerModal(){
                this.$store.dispatch('hideAddContainerModal')
            },
            submit() {
                this.$Progress.start()
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('createNewContainerFromModal', {
                        serialNr: this.serialNr,
                        company: this.company,
                        year: this.year,
                        volume: this.volume
                    })
                } else {
                    this.$Progress.fail()
                }
            }
        }
    }
</script>

<style scoped>

</style>